import { useEffect, useState } from 'react';
import { selectionProcessesPublic } from '@/services/selectionProcesses';

export default function RegionalInstitutionPicker({ slug, regionalId, institutionId, onChange, disabled = false }) {
  const [regionals, setRegionals] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [loadingInst, setLoadingInst] = useState(false);

  useEffect(() => {
    selectionProcessesPublic
      .listRegionals(slug)
      .then(res => setRegionals(res.data || []))
      .catch(() => setRegionals([]));
  }, [slug]);

  useEffect(() => {
    if (!regionalId) {
      setInstitutions([]);
      return;
    }
    setLoadingInst(true);
    selectionProcessesPublic
      .listInstitutions(regionalId)
      .then(res => setInstitutions(res.data || []))
      .finally(() => setLoadingInst(false));
  }, [regionalId]);

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <label className="flex flex-col">
        <span className="text-sm font-medium">Regional</span>
        <select
          value={regionalId || ''}
          disabled={disabled}
          onChange={e => onChange({ regional_id: Number(e.target.value) || '', institution_id: '' })}
          className="rounded border p-2"
        >
          <option value="">Selecione...</option>
          {regionals.map(r => (
            <option
              key={r.id}
              value={r.id}
            >
              {r.name}
            </option>
          ))}
        </select>
      </label>
      <label className="flex flex-col">
        <span className="text-sm font-medium">Unidade de Ensino</span>
        <select
          value={institutionId || ''}
          disabled={disabled || !regionalId || loadingInst}
          onChange={e => onChange({ institution_id: Number(e.target.value) || '' })}
          className="rounded border p-2"
        >
          <option value="">{loadingInst ? 'Carregando...' : 'Selecione...'}</option>
          {institutions.map(i => (
            <option
              key={i.id}
              value={i.id}
            >
              {i.name} — {i.city}/{i.state}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
